export const UPDATE_HOME_DASHBOARD_DATA = "UPDATE_HOME_DASHBOARD_DATA"
export const UPDATE_HOME_DASHBOARD_LOADING = "UPDATE_HOME_DASHBOARD_LOADING"
export const UPDATE_HOME_DASHBOARD_ACCOUNT_CHOICE = "UPDATE_HOME_DASHBOARD_ACCOUNT_CHOICE"
export const UPDATE_HOME_DASHBOARD_FILTER = "UPDATE_HOME_DASHBOARD_FILTER"